import callApi, { CallApiResult, getCustomerId } from 'src/api';

/* Customer Messages (customer-visible notes, F-KD-02) */

export const fetchCustomerMessages = (): Promise<CallApiResult> => callApi(`/api/customer/${getCustomerId()}/notes`);

export const markCustomerMessageRead = (messageId: string): Promise<CallApiResult<void>> =>
    callApi(`/api/customer/${getCustomerId()}/notes/${messageId}/read`, { method: 'POST' });
